import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import TwoInputModal from '../../common/TwoInputModal'

import * as Functions from '../../../helpers/Functions'
import * as Strings from './strings'
import * as configActions from '../../../actions/Config'
import * as userActions from '../../../actions/User'

class EditEmailModal extends Component {
  state = {
    emailInput: '',
    repeatEmailInput: '',
    errorEmail: '',
    errorRepeatEmail: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, user } = this.props

    if (nextProps.config.showEditEmailModal && !config.showEditEmailModal) {
      this.setState({
        emailInput: nextProps.data.user.email,
        repeatEmailInput: nextProps.data.user.email,
        errorEmail: '',
        errorRepeatEmail: '',
        errorMessage: ''
      })
    }

    if (
      !nextProps.user.isUpdating &&
      nextProps.user.errorUpdating === null &&
      user.isUpdating
    ) {
      this.props.hideEditEmailModal()
    } else if (
      !nextProps.user.isUpdating &&
      nextProps.user.errorUpdating !== null &&
      user.isUpdating
    ) {
      if (nextProps.user.errorUpdating === 409) {
        this.setState({
          errorEmail: Strings.default.EMAIL_IN_USE[config.language]
        })
      } else {
        this.setState({
          errorMessage: Strings.default.INTERNAL_ERROR[config.language]
        })
      }
    }
  }

  update() {
    const { user, config } = this.props
    const { emailInput, repeatEmailInput } = this.state

    this.setState({ errorMessage: '' })

    if (emailInput !== repeatEmailInput) {
      this.setState({
        errorEmail: Strings.default.EMAILS_DO_NOT_MATCH[config.language],
        errorRepeatEmail: Strings.default.EMAILS_DO_NOT_MATCH[config.language]
      })
    } else {
      if (emailInput === '' || !Functions.isValidEmail(emailInput)) {
        if (emailInput === '') {
          this.setState({
            errorEmail: Strings.default.MANDATORY_FIELD[config.language]
          })
        } else {
          this.setState({
            errorEmail: Strings.default.NOT_VALID_EMAIL[config.language]
          })
        }
      }

      if (repeatEmailInput === '') {
        this.setState({
          errorRepeatEmail: Strings.default.MANDATORY_FIELD[config.language]
        })
      }

      if (
        emailInput !== '' &&
        repeatEmailInput !== '' &&
        Functions.isValidEmail(emailInput)
      ) {
        const postData = { email: emailInput }

        this.props.tryUpdateSelf(user.token, postData)
      }
    }
  }

  render() {
    const { config, user } = this.props
    const {
      emailInput,
      repeatEmailInput,
      errorEmail,
      errorRepeatEmail,
      errorMessage
    } = this.state

    return (
      <TwoInputModal
        show={config.showEditEmailModal}
        onHide={() => this.props.hideEditEmailModal()}
        placeholders={[
          Strings.default.EMAIL[config.language],
          Strings.default.REPEAT_EMAIL[config.language]
        ]}
        inputs={[emailInput, repeatEmailInput]}
        onChange1={text =>
          this.setState({ emailInput: text, errorEmail: '', errorMessage: '' })
        }
        onChange2={text =>
          this.setState({
            repeatEmailInput: text,
            errorRepeatEmail: '',
            errorMessage: ''
          })
        }
        errors={[errorEmail, errorRepeatEmail, errorMessage]}
        header={Strings.default.EDIT_EMAIL[config.language]}
        onDone={() => this.update()}
        loading={user.isUpdating}
        language={config.language}
      />
    )
  }
}

function mapStateToProps({ config, data, user }) {
  return { config, data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...userActions }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditEmailModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditEmailModal/index.js